<template>
    <div class="zebra-crossing-detail">

        <el-form :model="ruleForm" ref="ruleForm" :rules='rules' v-loading='loading' label-width="140px">

            <!-- 上级目录 当前名称 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="上级目录" >
                        <el-cascader
                            style='width: 200px'
                            :props="parentId"
                            clearable
                            v-model="ruleForm.parentId"
                            :show-all-levels='false'
                            @change="showSelect"
                        >
                            <template slot-scope="{ node, data }">
                                <span>{{ data.label }}</span>
                            </template>
                        </el-cascader>
                    </el-form-item>
                </el-col>

                <el-col :span="24">
                    <el-form-item label="当前名称" prop='name'>
                        <el-input v-model="ruleForm.name" style='width: 200px;'></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 描述 权限 -->
            <el-row>
                <el-col :span="24" v-if='typeof(ruleForm.parentId[0]) ==="string" && ruleForm.parentId[0].split("_")[1] === "group"'>
                    <el-form-item label="描述">
                        <el-input v-model="ruleForm.description" style='width: 200px;'></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="24" v-if='typeof(ruleForm.parentId[0]) ==="string" && ruleForm.parentId[0].split("_")[1] === "department" || "dpt"'>
                    <el-form-item label="权限">
                        <el-input v-model="ruleForm.order" style='width: 200px;'></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">{{ type == 'edit' ? '修改' : '创建' }}</el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
    </div>
</template>

<script>

    import { getRules } from './system.rules'

    import services from './system.services'

    const rules = getRules();

    export default {

        props: {
            type: {
                type: String,
                default: 'add'
            },
            row: Object,
            callback: Function
        },

        data() {
            return {
                ruleForm: {
                    parentId: [],
                },
                rules,
                loading: true,
                parentId: {
                    lazy: true,
                    checkStrictly: true,
                    lazyLoad (node, resolve) {
                        if (node.root) {
                            services.treeTop().then(res => {
                                const nodes = Array.from(res.list.map(item => {
                                    if (item.type ==='group') {
                                        return {
                                            value: item.id + "_" + item.type,
                                            label: item.name,
                                            leaf: true
                                        }
                                    }
                                    else {
                                        return {
                                            value: item.id + "_" + item.type,
                                            label: item.name,
                                            leaf: !item.children
                                        }
                                    }
                                }))
                                resolve(nodes);
                            })
                        } else {
                            let { value } = node
                            services.treeChildren({ id:value.split('_')[0], type: value.split('_')[1] }).then(res => {
                                const nodes = Array.from(res.list.map(item => {
                                        return  {
                                            value: item.id + "_" + item.type,
                                            label: item.name,
                                            leaf: !item.children
                                        }
                                    }
                                ))
                                resolve(nodes);
                            })
                        }
                    }
                }
            }
        },

        created() {
            // console.log(this.callback);
            if (this.type === 'edit') {
                this.$modal.title = '编辑'
                this.ruleForm = {
                    parentId: [this.row.index],
                    name: this.row.name,
                    order: this.row.order,
                    description: this.row.description,
                    id: this.row.id+ ''
                }
            }
            this.loading = false
        },

        methods: {
            showSelect(){
                // console.log(this.ruleForm.parentId);
            },
            // 确认提交按钮
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // console.log(444);

                        let parentId='0_department'
                        if (this.ruleForm.parentId.length===0){
                            // console.log(555);
                            parentId='0_department'
                        } else{
                            parentId = Array.isArray(this.ruleForm.parentId) ? this.ruleForm.parentId.pop() : '0_department'

                        }
                        let params = {
                            ...this.ruleForm,
                            parentId: parentId.split('_')[0]
                        }
                        if(this.type === 'add') {
                            if(parentId.split('_')[1] === 'department') {
                                this.request({ request: services.departmentAdd, params })
                            }else if (parentId.split('_')[1] === 'group'){
                                this.request({ request: services.groupAdd, params })
                            }
                        } else if (this.type === 'edit') {
                            if(parentId.split('_')[1] === 'department' || parentId.split('_')[1] === 'dpt') {
                                params = {
                                    departmentId: params.id,
                                    parentId: this.row.parentId,
                                    name: params.name,
                                    order: params.order
                                }
                                this.request({ request: services.departmentUpdate, params })
                            }else if (parentId.split('_')[1] === 'group'){
                                params = {
                                    groupId: params.id,
                                    name: params.name,
                                    description: params.description,
                                    parentId: this.row.parentId
                                }
                                this.request({ request: services.groupUpdate, params })
                            }
                        }
                    } else {
                        return false;
                    }
                });
            },

            // 重置
            resetForm(formName) {
                this.$refs[formName].resetFields()
            },

            // 发起请求
            request({ request, params }) {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                request(params)
                    .then( res => this.$message.success('创建成功'))
                    .catch(err => this.$message.error(err.message))
                    .finally(() => {
                        loading.close()
                        this.$modal.close()
                        // this.callback()
                        this.$router.push({
                            path:'/redirect',
                            query:{
                                url:'/systemPerson'
                            }
                        })
                    })
            }
        }
    }
</script>

<style>

</style>
